import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from "react-router-dom";
import { config } from "@/lib/config";
import VideoPlayer from "@/components/video-player";
import Csifestes from "@/components/csi-festes/csifestes";
import { ArticleSchema, BreadcrumbSchema } from '@/components/StructuredData'

export default function CsiFestes() {
  const pageRef = useRef<HTMLDivElement>(null);
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && pageRef.current) {
      setShowVideo(true);
    }
  }, []);

  const videoSources = [
    {
      src: `${config.basePath}/video/csifestesokt.mp4`,
      type: "video/mp4",
    },
  ];

  const icon: any = <i className="bi bi-check beart-icon1"></i>;
  const video = (
    <video
      autoPlay
      muted
      loop
      className="mx-auto my-auto w-full md:ml-8 md:mt-8 md:w-[400px]"
    >
      <source src="/video/csi-bg2.mp4?x=54645" type="video/mp4" />
    </video>
  );

  return (
    <>
      <Helmet>
        <title>Csí-festés | BeArt Művészetterápia</title>
        <meta name="description" content="Csí-festés - FESS A BENNED LAKÓ ÉLETENERGIÁVAL! Mozgás- és alkotásfókuszú önismereti csoport" />
        <link rel="canonical" href="https://beart.hu/csi-festes" />
      </Helmet>
      
      {/* Structured Data */}
      <ArticleSchema 
        headline="Csí-festés - FESS A BENNED LAKÓ ÉLETENERGIÁVAL!"
        description="Mozgás- és alkotásfókuszú önismereti csoport. Csikung gyakorlás és art coaching technikák kombinációja a stresszoldásra és az önismeret fejlesztésére."
        author={{ name: "BeArt Művészetterápia" }}
        publisher={{ 
          name: "BeArt Művészetterápia", 
          logo: { url: "https://beart.hu/images/beart-transparent-logo.webp" } 
        }}
        datePublished="2024-01-01"
        image="https://beart.hu/images/csi/csifestes-tengely.jpg"
        url="https://beart.hu/csi-festes"
      />
      <BreadcrumbSchema 
        items={[
          { name: "Főoldal", url: "https://beart.hu" },
          { name: "Csí-festés", url: "https://beart.hu/csi-festes" }
        ]} 
      />
      
      <div ref={pageRef}>
        <div className="beart-section">
          <div className="flex w-full justify-center">
            {showVideo && (
              <div className="w-[70%]">
                <VideoPlayer videoSrc={videoSources} loop={true} />
              </div>
            )}
          </div>
          <div className="csi-bg">
            <Csifestes />
          </div>
          <div className="csi-content">
            <h1 className="mb-2 mt-8 text-3xl font-bold text-green-600">
              Csí-festés
            </h1>
            <div className="font-bold text-amber-600">
              FESS A BENNED LAKÓ ÉLETENERGIÁVAL!
            </div>
            <div className="font-bold italic text-blue-700">
              Mozgás- és alkotásfókuszú önismereti csoport
            </div>
            <div className="block lg:flex">
              <div>
                <div className="mt-8 flex">
                  <div>
                    <i className="bi bi-palette mr-2 text-3xl text-green-500"></i>
                  </div>
                  <div>
                    A <strong>Csí-festés</strong> lényege, hogy megteremtjük
                    azokat a feltételeket, melyek biztosítják a benned lévő
                    energiák szabad áramlását. Csikung gyakorlás közben
                    ráhangolódsz azokra az érzetekre, amelyeket saját tested a
                    külvilágból közvetít számodra, az art coaching gyakorlatok
                    során pedig olyan technikákat ismersz meg, melyekkel
                    feszültségmentesen, ellazultan válaszolhatsz a kihívásokra.
                  </div>
                </div>
                <div className="mt-8 flex">
                  <div>
                    <i className="bi bi-people mr-2 text-3xl text-blue-800"></i>
                  </div>
                  <div>
                    <strong>Kiknek ajánljuk a programot?</strong> 18 évestől - 99
                    éves korig, bárkinek. Semmilyen előzetes rajztudás vagy taiji
                    és csikung tapasztalat nem szükséges a részvételhez!
                  </div>
                </div>
              </div>
              {/* {video}*/}
            </div>
            <div className="mt-8">
              {/*<HoleEffect imgSrc={`${config.basePath}/images/csi/csimage2.jpg`}>*/}
              <div className="bg-white bg-opacity-45 p-8 text-black">
                <div className="mt-8">
                  <div className="beart-subtitle">
                    MIÉRT VÁLASZD A CHÍ-FESTÉS CSOPORTOT?
                  </div>
                  <ul>
                    <li>
                      {icon} Mert magabiztossá tesz, és növeli az önbizalmadat
                    </li>
                    <li>
                      {icon} Jobban rálátsz önmagadra és a működésedre,
                      komfortzónád szélesedik, mélyebb önismeretet kapsz
                    </li>
                  </ul>
                </div>
                <div className="mt-8">
                  <div className="beart-subtitle">
                    Ha van olyan helyzet, mikor nehéz megszólalnod
                  </div>
                  <ul>
                    <li>{icon} A Chí-festés segít, hogy megtaláld a hangod</li>
                    <li>{icon} Fejleszti a kommunikációt</li>
                    <li>
                      {icon} Segít, ha állandóan feszültnek, idegesnek érzed magad
                    </li>
                    <li>
                      {icon} A Chí-festés taiji, csikung gyakorlatokkal és az
                      alkotási feladatokkal segít a stressz csökkentésében
                    </li>
                    <li>{icon} Segít a motiválatlanság legyőzésében</li>
                    <li>{icon} Hasznos eszköz a kiégés megelőzésében</li>
                  </ul>
                  <div className="beart-subtitle">
                    Ha egy nehéz helyzetben lefagysz, a Chí-festés gyakorlatai
                    segítenek
                  </div>
                  <ul>
                    <li>
                      {icon} Felismerni az érzelmeidet, így könnyebben mozdulsz el
                      egy nehéz helyzetből
                    </li>
                    <li>{icon} Az indulatok kezelésében, a dühkezelésben</li>
                    <li>
                      {icon} Abban, hogy megtaláld, és arra használd az energiát a
                      testedben, amire szeretnéd
                    </li>
                  </ul>
                  <div className="beart-subtitle">A Chí-festés</div>
                  <ul>
                    <li>{icon} Segít megtalálni a rejtett energiáidat</li>
                    <li>{icon} Növeli a kreativitásod</li>
                    <li>{icon} Magabiztossá tesz a mindennapokban</li>
                  </ul>
                </div>
              </div>
              {/* </HoleEffect>*/}
              <div>
                <div className="beart-subtitle">Módszerek</div>
                <ul>
                  <li>
                    Taiji és csikung gyakorlatok, relaxáció, meditáció, art
                    coaching eszközök, művészetterápiás elemek.
                  </li>
                  <li>
                    Eszközt adunk a kezedbe ahhoz, hogy a lefagyásból, a
                    mozdulatlanságból kilépj a szabad mozgásba, alkotásba.
                  </li>
                </ul>
              </div>

              <div className="mt-8 w-full animate-bounce p-4 text-left text-center animate-infinite">
                <Link
                  to={`${config.basePath}/kapcsolat/csi-festes`}
                  className="rounded-md bg-red-500 p-4 text-center font-bold text-white"
                >
                  Jelentkezz most!
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
